import classNames from "classnames";
import React, { useEffect } from "react";
import { InquiryStatus } from "../../../../domain/inquiry/Inquiry";
import { InquiryId } from "../../../../domain/inquiry/InquiryId";
import { Paths } from "../../../../Paths";
import { useAppDispatch } from "../../../../state/store";
import { getInquiryListAction, updateInquiryAction } from "../../../../state/usecase/inquiry/actions";
import { useInquiryList } from "../../../hooks/inquiry/useInquiryList";
import { Loading } from "../../common/Loading";
import StatusSelector from "../../inquiry/components/StatusSelector";
import { useNavigate } from "react-router-dom";

export default function InquiryList() {

    const dispatch = useAppDispatch();

    const { inquiries, processing } = useInquiryList();

    const navigate = useNavigate();

    useEffect(() => {
        dispatch(getInquiryListAction());
    }, [dispatch]);

    if (processing) {
        return <Loading/>;
    }

    const onClickRow = (id: string) => () => {
        navigate(`${Paths.admin}${Paths.inquiry}/${id}`);
    };

    const handleClickStatusSelect = (id: InquiryId) => (status: InquiryStatus) => {
        dispatch(updateInquiryAction({
            id: id,
            status: status,
            successMessage: "問い合わせステータスを更新しました"
        }));
    };

    return (
        <div className="inquiry_list">
            <h1 className="title">問い合わせ一覧</h1>
            <div className="container">
                <table>
                    <thead>
                        <tr>
                            <th className="createdAt">問い合わせ日時</th>
                            <th className="user_name">ユーザー</th>
                            <th className="category">カテゴリ</th>
                            <th className="status">ステータス</th>
                            <th className="content">問い合わせ内容</th>
                        </tr>
                    </thead>
                    <tbody>
                        { inquiries.map(inquiry => {
                            const deletedUser = inquiry.userName === null;
                            return (
                                <tr key={inquiry.id.value} onClick={onClickRow(inquiry.id.value)}>
                                    <td className="createdAt">{inquiry.createdAt.format("/")}</td>
                                    <td className={classNames("user_name", { "deleted_user": deletedUser })}>{inquiry.userName?.value ?? "削除済みユーザー"}</td>
                                    <td className="category">{inquiry.category.value}</td>
                                    <td className="status">
                                        <StatusSelector currentStatus={inquiry.status} handleSelectStatus={handleClickStatusSelect(inquiry.id)}/>
                                    </td>
                                    <td className="content">{inquiry.content.value}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
